import { render } from "./HomeDestaque.vue?vue&type=template&id=1e3e496a"
import script from "./HomeDestaque.vue?vue&type=script&lang=js"
export * from "./HomeDestaque.vue?vue&type=script&lang=js"

import "./HomeDestaque.vue?vue&type=style&index=0&id=1e3e496a&lang=scss"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__